/**
 * SUPER_ADMIN "delete user account" (#34).
 *
 * `test_account` and `other` wipe the account immediately. `tos_violation`
 * and `spam` soft-delete it (restorable for the pending window) and ban the
 * email.
 */
export const DELETION_REASONS = ['test_account', 'tos_violation', 'spam', 'other'];
export const SOFT_DELETE_REASONS = ['tos_violation', 'spam'];
export const isSoftDeleteReason = (reason) => SOFT_DELETE_REASONS.includes(reason);
/** Days a soft-deleted account waits before an admin may purge it. */
export const PENDING_DELETION_WINDOW_DAYS = 30;
